import React, { Component } from 'react';
import i from '../imports';

class HorizontalLine extends Component {
    render() {
        return (
            <i.Container>
                <i.Row>
                    <i.Col mdOffset={3} md={6} xsOffset={3} xs={6}>
                        <hr className='hred' />
                    </i.Col>
                </i.Row>
            </i.Container>
        );
    }
}

export default HorizontalLine;